import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PollingState } from './polling.reducer';

export const POLLING_FEATURE_KEY = 'polling';

export const getPollingState =
  createFeatureSelector<PollingState>(POLLING_FEATURE_KEY);

export const getPollingData = createSelector(getPollingState, (s) => s.data);

export const getPollingDataByOrderId = (orderId: string) =>
  createSelector(getPollingData, (data) => data[orderId]);
